import { colors } from '@aloft/toolkit-sui';

import { useChartHeight, useChartWidth, useOffset } from 'recharts';

const ENTRIES = [
  { label: 'Site Size', kind: 'line' as const, color: colors.graphChart3 },
  { label: 'Site Value', kind: 'square' as const, color: colors.graphChart },
  { label: 'A - Adverse', kind: 'square' as const, color: colors.graphAdverse },
  { label: 'N - Neutral', kind: 'square' as const, color: colors.graphNeutral },
  { label: 'B - Beneficial', kind: 'square' as const, color: colors.graphBeneficial },
];

export const SiteValueRechartsSvgLegend = () => {
  const width = useChartWidth();
  const height = useChartHeight();
  const offset = useOffset();
  if (width == null || height == null || offset == null) {
    return null;
  }

  const iconSize = 14;
  const gap = 6;
  const between = 14;
  const fontSize = 11;
  const charW = 5.9;

  const itemWidths = ENTRIES.map((e) => iconSize + gap + e.label.length * charW);
  const total = itemWidths.reduce((a, b) => a + b, 0) + between * (ENTRIES.length - 1);

  let cx = (width - total) / 2;
  const yMid = height - offset.bottom / 2;

  return (
    <g>
      {ENTRIES.map((e, i) => {
        const itemW = itemWidths[i] ?? 0;
        const node = (
          <g key={e.label} transform={`translate(${cx}, ${yMid})`}>
            {e.kind === 'line' ? (
              <line
                x1={0}
                y1={0}
                x2={iconSize}
                y2={0}
                stroke={e.color}
                strokeWidth={2}
                fill="none"
              />
            ) : (
              <rect
                x={0}
                y={-iconSize / 2}
                width={iconSize}
                height={iconSize}
                fill={e.color}
              />
            )}
            <text
              x={iconSize + gap}
              y={0}
              dominantBaseline="middle"
              fontSize={fontSize}
              fill={colors.textPrimary}
              fontFamily="system-ui, sans-serif"
            >
              {e.label}
            </text>
          </g>
        );
        cx += itemW + (i < ENTRIES.length - 1 ? between : 0);
        return node;
      })}
    </g>
  );
};
